import React from 'react';
import ReportTile from './ReportTile';
import Layout from '../../components/layout/Layout';
import CustomEmpty from '../../components/CustomEmpty';
import ReportSelectFilter from './ReportSelectFilter';
import FilterSidebar from '../../components/FilterSidebar';

import './reports.scss';

const { REPORT_TYPES } = require('../../core/constants').default;

export default function () {
    const { company, user } = this.props;
    const { isVisibleSidebar } = this.state;

    const allLinks = REPORT_TYPES;
    const links = [];
    if (Array.isArray(company.features) || true) {
        allLinks.forEach((item) => {
            if (company.features.find(feature => item.feature_id == feature.id) || item?.allow == true) {
                if (item.feature_id === 'dvr-health-report' && company.features.find(feature => feature.id === 'dvr-health-report-extended')) {
                    return;
                }
                links.push(item);
            }
        });
    }
    const clearParams = () => {
        const { actions } = this.props;
        actions.setDataEventToReportParams(null);
    }
    const items = links.sort((a,b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0).map((l) => (
        <ReportTile
            key={l.id}
            icon={l.icon}
            link={l.link}
            title={l.title}
            description={l.description}
            clearParams={clearParams.bind(this)}
            image={l.image} 
        />
    ));
    let display = (
        <div>
            <br />
            <br />
            <CustomEmpty />
        </div>
    );
    if (items.length) {
        display = (
            <div 
                className="links-container" 
                style={{ margin: isVisibleSidebar ? '16px 0 0 360px' : '16px 0 0 40px' }}
            >
                {items}
            </div>
        );
    }

    return (
        <Layout
            className="reports"
            title={<div>Reports</div>}
            headerTitle={<div>Reports Page</div>}
            showFooter={false}
        >
                
            <div className={`content-wrap${user?.userCompany?.currentAlert ? '-with-banner' : ''}`}>
                <FilterSidebar 
                    displayFilter={true} 
                    onToggleFilterSidebar={() => { this.setState({ isVisibleSidebar: !isVisibleSidebar }) }}
                >
                    <ReportSelectFilter reportOptions={links}/>
                </FilterSidebar>
                {display}
            </div>
        </Layout>
    );
}
